import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetAccountsApi } from "../../ApiRequests";

const branch = localStorage.getItem("branch");

export const fetchAccounts = createAsyncThunk("fetch/Accounts", async () => {
  try {
    let response;
    response = await GetAccountsApi();
    if (!response.data?.success) {
      showErrorToast(response.data.error.msg);
    } else if (response.data?.success) {
      return response.data.data.payload;
    }
  } catch (error) {
    console.log(error);
  }
  return [];
});

const AccountSlice = createSlice({
  name: "accounts-data",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAccounts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAccounts.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchAccounts.rejected, (state, action) => {
      state.isError = true;
      console.log("Error: ", action.error);
    });
  },
});

export default AccountSlice.reducer;
